module.exports = __webpack_public_path__ + "img/your-segments.8dfdda0a.png";